<div [formGroup]="form">
  <!-- Row 1: Portal Name / URL -->
  <div class="row">
    <div [ngClass]="form.get('portalName')?.value === 'other' ? 'col-md-4' : 'col-md-6'">
      <div class="form-group mb-3">
        <label for="portalName" class="form-label"
          >{{ labels.nameOfPortal }} <span class="ast">*</span></label
        >
        <select
          id="portalName"
          class="form-control"
          formControlName="portalName"
          [class.is-invalid]="isFieldInvalid('portalName')"
        >
          <option value="" disabled selected>
            {{ placeholders.selectPortal }}
          </option>
          <option *ngFor="let portal of portals" [value]="portal.key">
            {{ portal.label }}
          </option>
        </select>
        <div class="invalid-feedback" *ngIf="isFieldInvalid('portalName')">
          {{ messages.fieldRequired }}
        </div>
      </div>
    </div>

    <div class="col-md-4" *ngIf="form.get('portalName')?.value === 'other'">
      <div class="form-group mb-3">
        <label for="otherPortal" class="form-label"
          >{{ labels.pleaseSpecify }} <span class="ast">*</span></label
        >
        <input
          type="text"
          id="otherPortal"
          class="form-control"
          formControlName="otherPortal"
          [class.is-invalid]="isFieldInvalid('otherPortal')"
          placeholder="{{ labels.pleaseSpecify }}"
          maxlength="100"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('otherPortal')">
          {{ messages.fieldRequired }}
        </div>
      </div>
    </div>

    <div [ngClass]="form.get('portalName')?.value === 'other' ? 'col-md-4' : 'col-md-6'">
      <div class="form-group mb-3">
        <label for="portalURL" class="form-label"
          >{{ labels.portalURL }}</label
        >
        <input
          type="text"
          id="portalURL"
          class="form-control"
          formControlName="portalURL"
          placeholder="{{ placeholders.enterURL }}"
          maxlength="100"
        />
      </div>
    </div>
  </div>

  <!-- Row 2: Description -->
  <div class="row">
    <div class="col-md-12">
      <div class="form-group mb-3">
        <label for="description" class="form-label"
          >{{ labels.describeRequest }} <span class="ast">*</span></label
        >
        <textarea
          id="description"
          class="form-control"
          formControlName="description"
          [class.is-invalid]="isFieldInvalid('description')"
          rows="4"
          placeholder="{{ placeholders.describeYourRequest }}"
          maxlength="2000"
        ></textarea>
        <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
          <span *ngIf="form.get('description')?.hasError('required')">
            {{ messages.fieldRequired }}
          </span>
          <span *ngIf="form.get('description')?.hasError('minlength')">
            {{ messages.characterLimit }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
